<div id="updateContent">
  <mat-icon>shopping_cart</mat-icon>
  <strong>Ihr Warenkorb wurde aktualisiert!</strong>
</div>
